import baseURL from '../common/axios';
class Commonservices {

    //To Insert Row-->Inventory API
    insertRow(dataModel) {
        return baseURL.httpMSInventoryUrl.post("RowMAS/Create", dataModel)
    }
    //To Update Row-->Inventory API
    updateRow(dataModel) {
        return baseURL.httpMSInventoryUrl.post("RowMAS/Update", dataModel)
    }
    //To Delete Row-->Inventory API
    deleteRow(Id) {
        return baseURL.httpMSInventoryUrl.delete("RowMAS/Delete?id=" + Id)
    }
    //To Delete Row-->Inventory API
    active(Id, Status) {
        return baseURL.httpMSInventoryUrl.put("RowMAS/Active?id=" + Id + "&Status=" + Status + "")
    }
    //To Get Row List-->Inventory API
    getRowList() {
        return baseURL.httpMSInventoryUrl.get("RowMAS/List")
    }
    //To Get Row List-->Inventory API
    getRowById(Id) {
        return baseURL.httpMSInventoryUrl.get("RowMAS/Get?id=" + Id + "")
    }
    //To get Row List based on RoomId-->Inventory API
    getRowByRoomId(Id) {
        debugger;
        let startDate = "2023-02-03T11:05:31.945Z";
        let endDate = "2023-02-03T11:05:31.945Z";
        return baseURL.httpMSInventoryUrl.get("Custom/ListRowMASByRoomMASId?ID=" + Id + "&startDate=" + startDate + "&endDate=" + endDate)
    }
    getRowByRackId(Id) {
        debugger;
        return baseURL.httpMSInventoryUrl.get("Custom/getRowByRackId?id=" + Id + "")
    }
}
export default new Commonservices()